module.exports = __webpack_public_path__ + "media/photo/group423-d45c1ef4.png";